import React from "react";

export default function AllHomesForSale() {
  return <div>AllHomesForSale</div>;
}
